import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineLite} from "gsap";
import {ThorGameConfig} from "../../ThorGameConfig";
import {ThorSoundConfig} from "../../ThorSoundConfig";

/**
 * Created by Jerker Nord on 2019-04-11.
 */

export class ThorHammertimeView extends BaseView {

    private static HAMMERTIME_ANIMATION_NAME:string = "Hammer";
    private static SPINE_ASSET_NAME:string = "hammerRaze";

    private _layer:ScalableLayer;
    private _hammertimeWonAnimation:PIXI.spine.Spine;
    private _showHammertimeTL:TimelineLite;
    private _hammerTimeSpineTween:SpineTween;

    constructor() {
        super();
        this._layer = StageManager.getLayer(ThorGameConfig.instance.LAYERS.RUNE_RAZE.name);
        this.alpha = 0;
        this._layer.addChild(this);
    }

    protected initAnimations():void {
        this._hammertimeWonAnimation = new PIXI.spine.Spine(GameResources.getSpineAsset(ThorHammertimeView.SPINE_ASSET_NAME));
        this._hammertimeWonAnimation.position.set(ThorGameConfig.instance.GAME_WIDTH / 2, (ThorGameConfig.instance.GAME_HEIGHT / 2) - 80);
        this.addChild(this._hammertimeWonAnimation);
    }

    private getHammertimeSpineTween():SpineTween {
        this._hammerTimeSpineTween = new SpineTween(this._hammertimeWonAnimation, 0, ThorHammertimeView.HAMMERTIME_ANIMATION_NAME, 0);
        return this._hammerTimeSpineTween;
    }

    private createShowTL():TimelineLite {
        this._showHammertimeTL = new TimelineLite();
        this._showHammertimeTL.add(() => this.alpha = 1);
        this._showHammertimeTL.add([
            this.getHammertimeSpineTween(),
            () => SlotGame.sound.playEffect(ThorSoundConfig.instance.HAMMERTIME_START)
        ]);
        this._showHammertimeTL.add(() => this.alpha = 0);

        this._hammertimeWonAnimation.state.timeScale = 1;
        this._showHammertimeTL.timeScale(1);

        //This i a hack to have something returned. The actual _showHammertimeTL animation needs to execute outside of the main timeline in the controller. Because that one is har set to the end time on abort. But we have our own abort function in this class that handles abort behaviour.
        return new TimelineLite();
    }

    public getShowHammertimeTL():TimelineLite {
        return this.createShowTL();
    }

    public abort():void {
        if(this._showHammertimeTL && this._showHammertimeTL.isActive() == true) {
            /*            this.alpha = 0;
                        this._showHammertimeTL.pause();
                        this._showHammertimeTL.kill();*/
            this._hammertimeWonAnimation.state.timeScale = 3;
            this._showHammertimeTL.timeScale(3);
        }
    }
}